/** Kaikki päivämäärälaskenta tehdään Suomen aikavyöhykkeellä. */
export const APP_TIME_ZONE = 'Europe/Helsinki';

/** Tämä päivä Suomen aikaa muodossa YYYY-MM-DD. */
export function todayIso(now: Date = new Date()): string {
  return new Intl.DateTimeFormat('sv-SE', {
    timeZone: APP_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(now);
}

/** "2026-10-05" → "5.10.2026" */
export function formatDate(isoDate: string, locale = 'fi-FI'): string {
  const [y, m, d] = isoDate.slice(0, 10).split('-').map(Number);
  return new Intl.DateTimeFormat(locale, { timeZone: 'UTC' }).format(
    new Date(Date.UTC(y!, m! - 1, d!)),
  );
}

/**
 * Seuraava eräpäivä annetusta päivästä alkaen (mukaan lukien). Jos kuussa ei ole
 * eräpäivää (esim. 31.), käytetään kuun viimeistä päivää.
 */
export function nextDueDate(dueDay: number, fromIso: string = todayIso()): string {
  const [y, m, d] = fromIso.split('-').map(Number) as [number, number, number];
  const lastDay = (year: number, month: number) => new Date(Date.UTC(year, month, 0)).getUTCDate();
  let year = y;
  let month = m;
  if (d > Math.min(dueDay, lastDay(year, month))) {
    month += 1;
    if (month > 12) {
      month = 1;
      year += 1;
    }
  }
  const day = Math.min(dueDay, lastDay(year, month));
  return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}

const pad = (n: number) => String(n).padStart(2, '0');

/** Kuukauden viimeinen päivä n kuukautta annetun päivän kuukauden jälkeen. */
function endOfMonthPlus(isoDate: string, months: number): string {
  const [y, m] = isoDate.split('-').map(Number) as [number, number];
  const target = new Date(Date.UTC(y, m - 1 + months + 1, 0));
  return `${target.getUTCFullYear()}-${pad(target.getUTCMonth() + 1)}-${pad(target.getUTCDate())}`;
}

/**
 * Viimeinen vuokrapäivä irtisanomisesta (laki asuinhuoneiston vuokrauksesta 52 §).
 * Irtisanomisaika lasketaan sen kuukauden viimeisestä päivästä, jona irtisanottiin:
 * vuokralainen 1 kk, vuokranantaja 3 kk tai 6 kk, jos vuokrasuhde on jatkunut vähintään
 * vuoden. Yhteisellä sopimuksella ja määräajan päättyessä päivä sovitaan, joten
 * ehdotuksena on irtisanomispäivä itse.
 */
export function noticeEndDate(
  by: 'tenant' | 'landlord' | 'mutual' | 'fixed_term',
  noticeOn: string,
  startDate: string,
): string {
  if (by === 'tenant') return endOfMonthPlus(noticeOn, 1);
  if (by === 'landlord') {
    const [y, m, d] = startDate.split('-').map(Number) as [number, number, number];
    const anniversary = `${y + 1}-${pad(m)}-${pad(d)}`;
    return endOfMonthPlus(noticeOn, noticeOn >= anniversary ? 6 : 3);
  }
  return noticeOn;
}
